<template>
    <UserBase>
        <div slot="content" class="page-user-account">
            <vue-headful 
            :title="$PPlusEngine.getDictionary($route.params.lang, 
                'แก้ไขบัญชี - ProbPlus', 
                'แก้ไขบัญชี - ProbPlus')" 
            :description="$PPlusEngine.getDictionary($route.params.lang, 
                'แก้ไขบัญชีส่วนตัวสำหรับใช้งานเว็บไซต์',
                'แก้ไขบัญชีส่วนตัวสำหรับใช้งานเว็บไซต์')" />
            <ContentLoader :isDisplay="!contentReady" />
            <template v-if="contentReady">
                <h1>{{ $PPlusEngine.getDictionary($route.params.lang, 'เปลี่ยนอีเมล', 'Change Email') }}</h1>
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'อีเมลเดิม', 'Current Email') }}</label>
                            <div class="input-icon">
                                <i class="pe-7s-mail"></i>
                                <input type="text" class="form-control" maxlength="100" :value="fields.email" readonly />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'อีเมลใหม่', 'New Email') }}</label>
                            <div class="input-icon">
                                <i class="pe-7s-mail"></i>
                                <input type="text" class="form-control" maxlength="100" :class="$PPlusEngine.highlightInvalidField(changeEmailValidate.newEmail.invalid)" v-model="changeEmailForm.newEmail" />
                            </div>
                            <span class="error-message" v-if="changeEmailValidate.newEmail.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'โปรดกรอกอีเมลใหม่', 'Please input your new email') }}</span>
                            <span class="error-message" v-if="changeEmailValidate.newEmail.format">{{ $PPlusEngine.getDictionary($route.params.lang, 'รูปแบบอีเมลไม่ถูกต้อง', 'Email format is invalid') }}</span>
                            <span class="error-message" v-if="changeEmailValidate.newEmail.same">{{ $PPlusEngine.getDictionary($route.params.lang, 'โปรดตั้งอีเมลใหม่ที่ไม่ซ้ำของเดิม', 'This is not new email') }}</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'ยืนยันอีเมล', 'Confirm Email') }}</label>
                            <div class="input-icon">
                                <i class="pe-7s-mail"></i>
                                <input type="text" class="form-control" maxlength="100" :class="$PPlusEngine.highlightInvalidField(changeEmailValidate.confirmEmail.invalid)" v-model="changeEmailForm.confirmEmail" />
                            </div>
                            <span class="error-message" v-if="changeEmailValidate.confirmEmail.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'โปรดยืนยันอีเมล', 'Please confirm email') }}</span>
                            <span class="error-message" v-if="changeEmailValidate.confirmEmail.match">{{ $PPlusEngine.getDictionary($route.params.lang, 'การยืนยันอีเมลใหม่ไม่ตรงกัน', 'Email confirm does not match') }}</span>
                        </div>
                    </div>
                </div>
                <span class="error-message" v-if="changeEmailValidate.form.invalid">{{ changeEmailValidate.form.message }}</span>
                <div class="action">
                    <button class="btn btn-secondary" @click="submitChangeEmail()">{{ $PPlusEngine.getDictionary($route.params.lang, 'บันทึก', 'Save') }}</button>
                </div>
                
                <br />
                <br />

                <h2>{{ $PPlusEngine.getDictionary($route.params.lang, 'เปลี่ยนรหัสผ่าน', 'Change Password') }}</h2>
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'รหัสผ่านเดิม', 'Current Password') }}</label>
                            <div class="input-icon">
                                <i class="pe-7s-door-lock"></i>
                                <input type="password" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(changePasswordValidate.currentPassword.invalid)" v-model="changePasswordForm.currentPassword" />
                            </div>
                            <span class="error-message" v-if="changePasswordValidate.currentPassword.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'โปรดกรอกรหัสผ่านเดิม', 'Please input your current password') }}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'รหัสผ่านใหม่', 'New Password') }}</label>
                            <div class="input-icon">
                                <i class="pe-7s-door-lock"></i>
                                <input type="password" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(changePasswordValidate.newPassword.invalid)" v-model="changePasswordForm.newPassword" />
                            </div>
                            <span class="error-message" v-if="changePasswordValidate.newPassword.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'โปรดกรอกรหัสผ่านใหม่', 'Please input your new password') }}</span>
                            <span class="error-message" v-if="changePasswordValidate.newPassword.length">{{ $PPlusEngine.getDictionary($route.params.lang, 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร', 'Password requires at least 8 characters') }}</span>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <div class="form-group">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'ยืนยันรหัสผ่าน', 'Confirm Password') }}</label>
                            <div class="input-icon">
                                <i class="pe-7s-door-lock"></i>
                                <input type="password" class="form-control" maxlength="50" :class="$PPlusEngine.highlightInvalidField(changePasswordValidate.confirmPassword.invalid)" v-model="changePasswordForm.confirmPassword" />
                            </div>
                            <span class="error-message" v-if="changePasswordValidate.confirmPassword.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'โปรดยืนยันรหัสผ่าน', 'Please confirm new password') }}</span>
                            <span class="error-message" v-if="changePasswordValidate.confirmPassword.match">{{ $PPlusEngine.getDictionary($route.params.lang, 'การยืนยันรหัสผ่านใหม่ไม่ตรงกัน', 'Confirm password does not match') }}</span>
                        </div>
                    </div>
                </div>
                <span class="error-message" v-if="changePasswordValidate.form.invalid">{{ changePasswordValidate.form.message }}</span>
                <div class="action">
                    <button class="btn btn-secondary" @click="submitChangePassword()">{{ $PPlusEngine.getDictionary($route.params.lang, 'บันทึก', 'Save') }}</button>
                </div>
            </template>
        </div>
    </UserBase>
</template>

<script>
import UserBase from '@/pages/UserBase';
import ContentLoader from '@/weact/components/ContentLoader';
import PPlusNotify from '@/resources/PPlusNotify';

export default {
    mixins: [PPlusNotify],
    components: {
        UserBase,
        ContentLoader
    },
    data() {
        return {
            contentReady: false,
            fields: {},
            changeEmailForm: this.initModelChangeEmail(),
            changeEmailValidate: this.initValidateChangeEmail(),
            changePasswordForm: this.initModelChangePassword(),
            changePasswordValidate: this.initValidateChangePassword()
        }
    },
    created() {
        let page = this;
        
        setTimeout(function(){
            page.getContent();
        }, this.$WeConfig.TimeLoader);
    },
    methods: {
        getContent() {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {};

            this.$WeHelper.postAPI(apiURL, '/api/user/get-account-content', postData, this.$PPlusEngine.getHeaderToken()).then((response) => {
                this.fields = response.data;
                this.contentReady = true;
            });
        },
        initModelChangeEmail() {
            return { newEmail: '', langCode: this.$route.params.lang };
        },
        initModelChangePassword() {
            return { currentPassword: '', newPassword: '', langCode: this.$route.params.lang };
        },
        initValidateChangeEmail() {
            return { 
                newEmail: { invalid: false, blank: false, format: false, same: false }, 
                confirmEmail: { invalid: false, blank: false, match: false },
                form: { invalid: false, message: '' }
            }
        },
        initValidateChangePassword() {
            return { 
                currentPassword: { invalid: false, blank: false }, 
                newPassword: { invalid: false, blank: false, length: false },
                confirmPassword: { invalid: false, blank: false, match: false },
                form: { invalid: false, message: '' }
            }
        },
        submitChangeEmail() {
            this.changeEmailValidate = this.initValidateChangeEmail();

            if (!this.validateChangeEmailField()) {
                let loader = this.$WeHelper.modalLoad();
                let apiURL = this.$PPlusConfig.ApiURL;

                this.$WeHelper.postAPI(apiURL, '/api/user/submit-change-email', this.changeEmailForm, this.$PPlusEngine.getHeaderToken()).then((response) => {
                    loader.hide();

                    if (response.data) {
                        if (response.data.success) {
                            let timerInterval;
                            let page = this;

                            this.$swal({
                                title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'เปลี่ยนอีเมลใช้งานเสร็จแล้ว', 
                                        'เปลี่ยนอีเมลใช้งานเสร็จแล้ว'),
                                html: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'กำลังออกจากระบบในอีก <span>8</span> วินาที จากนั้นโปรดทำการเข้าสู่ระบบใหม่อีกครั้งด้วยอีเมลใหม่', 
                                        'กำลังออกจากระบบในอีก <span>8</span> วินาที จากนั้นโปรดทำการเข้าสู่ระบบใหม่อีกครั้งด้วยอีเมลใหม่'),
                                timer: 8000,
                                type: 'success',
                                confirmButtonText: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'รับทราบ', 
                                        'รับทราบ'),
                                onBeforeOpen: () => {
                                    timerInterval = setInterval(() => {
                                        page.$swal.getContent().querySelector('span').textContent = Math.ceil(page.$swal.getTimerLeft() / 1000)
                                    }, 1000)
                                },
                                onClose: () => {
                                    clearInterval(timerInterval);
                                    this.$WeHelper.modalLoad();
                                    this.$cookie.delete('token');
                                    location.reload();
                                }
                            });
                        }
                        else {
                            this.changeEmailValidate.form.invalid = true;
                            this.changeEmailValidate.form.message = response.data.message;
                        }
                    }
                    else {
                        this.alertSystemError();
                    }
                });
            }
        },
        submitChangePassword() {
            this.changePasswordValidate = this.initValidateChangePassword();

            if (!this.validateChangePasswordField()) {
                let loader = this.$WeHelper.modalLoad();
                let apiURL = this.$PPlusConfig.ApiURL;

                this.$WeHelper.postAPI(apiURL, '/api/user/submit-change-password', this.changePasswordForm, this.$PPlusEngine.getHeaderToken()).then((response) => {
                    loader.hide();

                    if (response.data) {
                        if (response.data.success) {
                            let timerInterval;
                            let page = this;

                            this.$swal({
                                title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'เปลี่ยนรหัสผ่านเสร็จแล้ว', 
                                        'เปลี่ยนรหัสผ่านเสร็จแล้ว'),
                                html: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'กำลังออกจากระบบในอีก <span>8</span> วินาที จากนั้นโปรดทำการเข้าสู่ระบบใหม่อีกครั้งด้วยระหัสผ่านใหม่', 
                                        'กำลังออกจากระบบในอีก <span>8</span> วินาที จากนั้นโปรดทำการเข้าสู่ระบบใหม่อีกครั้งด้วยระหัสผ่านใหม่'),
                                timer: 8000,
                                type: 'success',
                                confirmButtonText: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                                        'รับทราบ', 
                                        'รับทราบ'),
                                onBeforeOpen: () => {
                                    timerInterval = setInterval(() => {
                                        page.$swal.getContent().querySelector('span').textContent = Math.ceil(page.$swal.getTimerLeft() / 1000)
                                    }, 1000)
                                },
                                onClose: () => {
                                    clearInterval(timerInterval);
                                    this.$WeHelper.modalLoad();
                                    this.$cookie.delete('token');
                                    location.reload();
                                }
                            });
                        }
                        else {
                            this.changePasswordValidate.form.invalid = true;
                            this.changePasswordValidate.form.message = response.data.message;
                        }
                    }
                    else {
                        this.alertSystemError();
                    }
                });
            }
        },
        validateChangeEmailField() {
            var isError = false;

            if (!this.changeEmailForm.newEmail) {
                this.changeEmailValidate.newEmail.invalid = true;
                this.changeEmailValidate.newEmail.blank = true;
                isError = true;
            }
            if (!this.$WeHelper.validateEmail(this.changeEmailForm.newEmail)) {
                this.changeEmailValidate.newEmail.invalid = true;
                this.changeEmailValidate.newEmail.format = true;
                isError = true;
            }
            if (this.changeEmailForm.newEmail.trim() == this.fields.Email) {
                this.changeEmailValidate.newEmail.invalid = true;
                this.changeEmailValidate.newEmail.same = true;
                isError = true;
            }
            if (!this.changeEmailForm.confirmEmail) {
                this.changeEmailValidate.confirmEmail.invalid = true;
                this.changeEmailValidate.confirmEmail.blank = true;
                isError = true;
            }
            if (this.changeEmailForm.confirmEmail && this.changeEmailForm.newEmail != this.changeEmailForm.confirmEmail) {
                this.changeEmailValidate.confirmEmail.invalid = true;
                this.changeEmailValidate.confirmEmail.match = true;
                isError = true;
            }

            return isError;
        },
        validateChangePasswordField() {
            var isError = false;

            if (!this.changePasswordForm.currentPassword) {
                this.changePasswordValidate.currentPassword.invalid = true;
                this.changePasswordValidate.currentPassword.blank = true;
                isError = true;
            }
            if (!this.changePasswordForm.newPassword) {
                this.changePasswordValidate.newPassword.invalid = true;
                this.changePasswordValidate.newPassword.blank = true;
                isError = true;
            }
            if (this.changePasswordForm.newPassword && this.changePasswordForm.newPassword.length < 8) {
                this.changePasswordValidate.newPassword.invalid = true;
                this.changePasswordValidate.newPassword.length = true;
                isError = true;
            }
            if (!this.changePasswordForm.confirmPassword) {
                this.changePasswordValidate.confirmPassword.invalid = true;
                this.changePasswordValidate.confirmPassword.blank = true;
                isError = true;
            }
            if (this.changePasswordForm.confirmPassword && this.changePasswordForm.newPassword != this.changePasswordForm.confirmPassword) {
                this.changePasswordValidate.confirmPassword.invalid = true;
                this.changePasswordValidate.confirmPassword.match = true;
                isError = true;
            }

            return isError;
        }
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-user-account {
    h1, h2 {
        font-size: 22px;
        color: $mainColor;
        margin: 0 0 15px;
        padding-bottom: 10px;
        border-bottom: 1px dashed #ddd;
    }
}
</style>